import { render } from "./Lockers.vue?vue&type=template&id=44a1d8fa"
import script from "./Lockers.vue?vue&type=script&lang=js"
export * from "./Lockers.vue?vue&type=script&lang=js"

import "./Lockers.vue?vue&type=style&index=0&id=44a1d8fa&lang=css"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__